import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FocusModeProvider } from './FocusModeContext';  // ✅ IMPORT CONTEXT PROVIDER

if (!localStorage.getItem('userId')) {
  localStorage.setItem(
    'userId',
    (window.crypto && crypto.randomUUID)
      ? crypto.randomUUID()
      : Math.random().toString(36).substring(2) + Date.now()
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FocusModeProvider>
      <App />
    </FocusModeProvider>
  </React.StrictMode>
);

reportWebVitals();
